import React from "react";
import { ArrowUpRight } from "lucide-react";
import insightsManifest from "../content/insights-manifest.json";
import { insights as fallbackInsights } from "../mock/mock";

// The build script (/app/scripts/build-insights.js) regenerates
// insights-manifest.json from the markdown sources on every `yarn build`.
// We fall back to the legacy mock list if the manifest is empty so the
// homepage never breaks during development.
const POSTS = (insightsManifest && insightsManifest.length > 0
  ? insightsManifest.slice(0, 3).map((p) => ({
      id:       p.slug,
      url:      p.url,
      title:    p.title,
      excerpt:  p.excerpt,
      category: p.category,
      readTime: p.readTime,
      date:     p.dateLabel || p.date,
    }))
  : fallbackInsights.map((p) => ({ ...p, url: "/insights.html" }))
);

const Insights = () => {
  return (
    <section
      id="insights"
      aria-labelledby="insights-heading"
      className="relative py-24 md:py-32 border-t border-[#E5E5E0]"
      data-testid="insights-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6b6b66] mb-3">
              — (06) Field notes
            </p>
            <h2
              id="insights-heading"
              className="font-display text-3xl md:text-5xl font-medium leading-tight max-w-2xl"
            >
              Notes from the new search frontier.
            </h2>
          </div>
          <a
            href="/insights.html"
            className="link-underline self-start md:self-end font-mono text-[11px] uppercase tracking-[0.2em] text-[#0A0A0A]"
            data-testid="insights-all-link"
          >
            All writing →
          </a>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E5E5E0] border-y border-[#E5E5E0]"
          data-testid="insights-grid"
        >
          {POSTS.map((p) => (
            <a
              key={p.id}
              href={p.url}
              className="group bg-[#FAFAF7] hover:bg-[#F2F1EC] transition-colors p-6 md:p-8 flex flex-col"
              data-testid={`insights-card-${p.id}`}
            >
              <div className="flex items-center justify-between mb-6">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#0A0A0A] bg-[#C8FF3D] px-2 py-1">
                  {p.category}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#6b6b66]">
                  {p.date}
                </span>
              </div>
              <h3 className="font-display text-xl md:text-2xl leading-snug font-medium mb-3 flex-1">
                {p.title}
              </h3>
              <p className="text-[14px] text-[#2a2a2a] leading-relaxed mb-6">
                {p.excerpt}
              </p>
              <div className="flex items-center justify-between border-t border-[#E5E5E0] pt-4">
                <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#6b6b66]">
                  {p.readTime}
                </span>
                <span className="h-9 w-9 rounded-full border border-[#0A0A0A] flex items-center justify-center group-hover:bg-[#0A0A0A] group-hover:text-[#C8FF3D] transition-colors">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Insights;
